import conf from './_conf';
import { workName, emitUpload, updatePage } from './_upload';

export const emitRouter = name => {
  if (!conf[workName].router[name]) return;
  let newPageName = conf[workName].router[name].event;
  if (!newPageName) return;
  // 更新页面值
  updatePage(newPageName);
  // 触发进入页面上报
  emitUpload(`enter-${newPageName}`, conf[workName].router[name]);
};
